// src/components/Dashboard/PieChart.jsx
import React from "react";
import { Pie } from "react-chartjs-2";
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";

ChartJS.register(ArcElement, Tooltip, Legend);

function PieChart({ title, pieData = [], orderDetailsDatas = [] }) {
  const orderDetailsData = [
    { label: "Approved", value: 38.6, percentage: "38.6", color: "#FFB800" },
    { label: "Processed", value: 22.5, percentage: "22.5", color: "#0066B2" },
    { label: "Failed", value: 30.8, percentage: "30.8", color: "#CCCCCC" },
  ];

  const kycStatusData = [
    { label: "Pending", value: 38.6, percentage: "38.6", color: "#FFB800" },
    {
      label: "Update Request",
      value: 22.5,
      percentage: "22.5",
      color: "#0066B2",
    },
    {
      label: "Query raised",
      value: 30.8,
      percentage: "30.8",
      color: "#FF0000",
    },
    { label: "Under Review", value: 8.1, percentage: "8.1", color: "#CCCCCC" },
  ];

  const data = title === "Order Details" ? orderDetailsDatas : pieData;

  const chartData = {
    labels: data?.map((item) => item?.label),
    datasets: [
      {
        data: data?.map((item) => item?.value),
        backgroundColor: data?.map((item) => item?.color),
        borderWidth: 0,
      },
    ],
  };

  const options = {
    plugins: {
      legend: {
        display: false, // Disable default legend
      },
      tooltip: {
        enabled: true,
      },
    },
    cutout: "0%",
    radius: "70%",
    maintainAspectRatio: false,
  };

  return (
    <div className="w-full h-full p-4">
      <h2 className="text-[#0066B2] text-lg font-bold mb-4">{title}</h2>
      <div className="flex flex-col md:flex-row">
        <div className="w-full md:w-[50%] h-[250px] md:ml-[-30px] md:mb-[-40px] md:mt-[-50px]">
          <Pie data={chartData} options={options} />
        </div>
        <div className="w-full md:w-[50%] flex flex-col justify-center gap-2 mt-4 md:mt-0 md:ml-4">
          {data?.map((item, index) => (
            <div key={index} className="flex items-center justify-between">
              <div className="flex items-center gap-2">
                <div
                  className="w-3 h-3 rounded-full"
                  style={{ backgroundColor: item?.color }}
                />
                <span className="text-sm">{item?.label}</span>
              </div>
              <span className="text-sm">{item?.percentage}%</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default PieChart;
